<template>
  <div class="s-vehicles-compare-bar">
    <div class="page-container">
      <div class="row align-items-center">
        <div class="col-md-9">
          <div class="row align-items-center">
            <div v-for="item in records" :key="item.id" class="col-md-4">
              <VehicleCompareBarCard :item="item" />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div v-if="records.length === 1">
            <span class="semibold">
              {{ dictionary.compareMinLengthText }}
            </span>
          </div>
          <div v-else>
            <button
              type="button"
              class="btn btn-outline-primary btn-full-width"
              @click="onClickCompare">
              {{ dictionary.buttonCompareButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleCompareBarCard from './VehicleCompareBarCard.vue'

export default {
  components: { VehicleCompareBarCard },
  props: {
    records: {
      required: true,
      type: Array,
    },
  },
  methods: {
    onClickCompare() {
      window.location.assign(
        `${this.configuration.comparePageUrl}?vehicles=${this.records
          .map((x) => x.id)
          .join()}`
      )
    },
  },
}
</script>
